module.exports = {
//    apiUrl: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL : 'http://localhost:5001/api'
    apiUrl: process.env.VUE_APP_API_URL
}

